module.exports = __webpack_public_path__ + "img/437-dfc4b4.png";